module.exports = __webpack_public_path__ + "static/media/arts_25.6728208f.jpg";